var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProtectamUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 0L0 3.63636V9.09091C0 14.1364 3.49091 18.8545 8.18182 20C12.8727 18.8545 16.3636 14.1364 16.3636 9.09091V3.63636L8.18182 0ZM8.18182 9.99091H14.5455C14.0636 13.7364 11.5636 17.0727 8.18182 18.1182V10H1.81818V4.81818L8.18182 1.99091V9.99091Z",
    fill: "#003393"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectamUpdates);
export default __webpack_public_path__ + "static/media/protectam_updates.62d6f6f32f72e320b4efa8d96d0c84f9.svg";
export { ForwardRef as ReactComponent };